import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-skeleton-treatment',
  templateUrl: './skeleton-treatment.component.html',
  styleUrls: ['./skeleton-treatment.component.scss']
})
export class SkeletonTreatmentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
